import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CandidateTypeComponent } from './candidate-type.component';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonService } from './../../services/common.service';
import { InternationalPhoneNumberModule } from 'ng-phone-number';

@NgModule({
  imports: [
    CommonModule,
    NgxDatatableModule,
    FormsModule,
    ReactiveFormsModule,
    InternationalPhoneNumberModule
  ],
  declarations: [CandidateTypeComponent],
  exports: [CandidateTypeComponent],
  providers: [CommonService]
})
export class CandidateTypeModule { }
